'use strict';
var versionHelper = require('../helper/versionHelper');

module.exports = {
  CurrentPropsMap: {
    color : 'currentColor',
    text : 'currentText',
    left : 'currentX',
    top : 'currentY',
    width : 'currentW',
    height : 'currentH',
    scaleX : 'currentScaleX',
    scaleY : 'currentScaleY',
    rotate : 'currentAngle',
    popup : 'currentPopupState',
    visible : 'currentVisible',
    nextIndex : 'currentIndex',
    textColor : 'currentTextColor'
  },

  //同步組內組件的可見性
  updateChildDomVisible: function(groupCom, visible) {
    var item;
    var childDom;
    var i = 0;

    //兼容3.2.6后隐藏策略调整
    if(!versionHelper.isPageVersionLowerThan4_9()) {
      return;
    }

    if (groupCom.items) {
      for (i; i < groupCom.items.length; i++) {
        item = groupCom.items[i];
        childDom = $('#' + item.controlID);
        childDom.css({visibility: visible ? 'visible' : 'hidden'});
        if (item.items) {
          this.updateChildDomVisible(item, visible);
        }
      }
    }
  },

  doUpdateChildVisible: function(groupCom, visible) {
    var item;
    var i = 0;

    //兼容3.2.6后隐藏策略调整
    if(!versionHelper.isPageVersionLowerThan4_9()) {
      return;
    }

    if (groupCom.items) {
      for (i; i < groupCom.items.length; i++) {
        item = groupCom.items[i];
        item.currentVisible = visible;
        if (item.items) {
          this.doUpdateChildVisible(item, visible);
        }
      }
    }
  },

  //返回值是所有连接点的交互数据
  getInteractiveByComp: function(comp) {
    var i = 0;
    var links;
    var entries;
    var result = [];
    var l = 0;

    if (props.interactiveData) {
      entries = props.interactiveData.entry;
      if (entries) {
        l = entries.length;
        for (i=0; i < l; i++) {
          if (this.isValidInteractive(entries[i])) {
            result.push({entry: entries[i]});
          } else {
            result.push({});
          }
        }

      }
    }
    if (props.links && props.links.link) {
      links = props.links.link;
      l = links.length;
      for (i=0; i < l; i++) {
        if(!result[i]) {
          result[i] = {};
        }
        if (this.isValidLink(links[i])) {
          result[i].link = links[i];
        }
      }
    }

    return result;
  },

  isValidLink: function (link) {
    if (link && link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK) {
      return true;
    }
    return false;
  },

  isValidEntry: function (entry) {
    if (entry && entry.events && entry.events.event && entry.events.event.length) {
      return true;
    }
    return false;
  },

  isValidInteractive : function(entry){
    var i;
    var j;
    var c = false;
    var e;
    var t;
    var b;
    if(entry.events && entry.events.event){
      for(i = 0;i<entry.events.event.length;i++){
        e = entry.events.event[i];
        if(e.isChecked){
          b = e.behaviour[0];
          for(j = 0;j< b.target.length;j++){
            t = b.target[j];
            if(t &&　t.isChecked){
              c = true;
              break;
            }
          }
          if(c){
            break;
          }
        }
      }
    }
    return c;
  },
};


// WEBPACK FOOTER //
// ./src/interactive/InteractiveHelper.js